import React, { useState, createContext, useContext } from "react";
import { Radio, Select, Form, Skeleton,  notification } from "antd";
import MonthlysettingStore from "../store/monthlysettingstore";
import { observer } from "mobx-react-lite";

const monthlySettingStoreCtx = createContext(MonthlysettingStore);
const _ = require("underscore");
const { Option } = Select;

export const Field = observer(() => {
  const [field, setField] = useState("0");
  const monthlySettingStore = useContext(monthlySettingStoreCtx);
  return (
    <div className="ms-Grid" dir="ltr">
      <div className="ms-Grid-row">
        <div
          className="ms-Grid-col ms-sm12"
          style={{ justifyContent: "center", display: "flex" }}
        >
          <Radio.Group
            buttonStyle="solid"
            onChange={({ target }) => {
              setField(target.value);
            }}
            defaultValue={field}
            value={field}
          >
            <Radio.Button value="0">Select Existing Field</Radio.Button>
            
          </Radio.Group>
        </div>
      </div>

      <div className="ms-Grid-row">
        {field === "0" && (
          <div
            className="ms-Grid-col ms-sm12"
            style={{
              padding: "20px",
              justifyContent: "center",
              display: "flex",
            }}
          >
            {monthlySettingStore.isloading ? (
              <>
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
              </>
            ) : (
              <Form.Item label="Field" required>
                <Select
                  showSearch
                  style={{ width: 200 }}
                  placeholder="Select Field"
                  optionFilterProp="children"
                  value={monthlySettingStore.selFieldId}
                  onChange={(value,selItem) => {
                    try {
                      
                      monthlySettingStore.selFieldId = value;
                      monthlySettingStore.selField=selItem.children
                      monthlySettingStore.loadFieldWells(
                        monthlySettingStore.selFieldId
                      );
                    } catch (error) {
                      notification.error({
                        message: "SPARS Feedback",
                        description: `hirerachy loading failed`,
                      });
                    }

                    // console.log(value)
                  }}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {_.uniq([...monthlySettingStore.hierarchy.values()].map(p=>{return {field:p.field,fieldId:p.fieldId}}),'field').map((f) => (
                    <Option key={f.fieldId} value={f.fieldId}>
                      {f.field}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
           
           )}
          </div>
        )}

        {/* {field === "1" && (
          <div
            className="ms-Grid-col ms-sm12"
            style={{
              padding: "20px",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <Form.Item label="Field" required>
              <Input
                value={monthlySettingStore.selFieldId}
                onChange={({ target }) => {
                  monthlySettingStore.selFieldId = target.value.toUpperCase();
                }}
              ></Input>
            </Form.Item>
          </div>
        )} */}
      </div>
    </div>
  );
});

